/**
 * Store builder font presets — values are API `site_style.font_pair` slugs.
 * Keep in sync with blu-storefront `builder/storeFontPairs.ts`.
 */
export const STORE_BUILDER_FONT_PAIRS = [
  { value: 'inter', labelKey: 'storeBuilder.siteStyle.fontInter' },
  { value: 'outfit', labelKey: 'storeBuilder.siteStyle.fontOutfit' },
  { value: 'nunito-sans', labelKey: 'storeBuilder.siteStyle.fontNunitoSans' },
  { value: 'rubik', labelKey: 'storeBuilder.siteStyle.fontRubik' },
  { value: 'mono-accent', labelKey: 'storeBuilder.siteStyle.fontMonoAccent' },
  { value: 'barlow-condensed-barlow', labelKey: 'storeBuilder.siteStyle.fontBarlow' },
  { value: 'oswald-open-sans', labelKey: 'storeBuilder.siteStyle.fontOswaldOpenSans' },
  { value: 'playfair-source', labelKey: 'storeBuilder.siteStyle.fontPlayfairSource' },
  { value: 'cormorant-montserrat', labelKey: 'storeBuilder.siteStyle.fontCormorantMontserrat' },
  { value: 'dm-serif-dm-sans', labelKey: 'storeBuilder.siteStyle.fontDmSerifDmSans' },
  { value: 'josefin-lato', labelKey: 'storeBuilder.siteStyle.fontJosefinLato' },
  { value: 'serif-modern', labelKey: 'storeBuilder.siteStyle.fontSerifModern' },
  { value: 'lora-inter', labelKey: 'storeBuilder.siteStyle.fontLoraInter' },
  { value: 'merriweather-lato', labelKey: 'storeBuilder.siteStyle.fontMerriweatherLato' },
  { value: 'crimson-inter', labelKey: 'storeBuilder.siteStyle.fontCrimsonInter' },
  { value: 'eb-garamond-inter', labelKey: 'storeBuilder.siteStyle.fontEbGaramondInter' },
  { value: 'pt-serif-inter', labelKey: 'storeBuilder.siteStyle.fontPtSerifInter' },
  { value: 'fraunces-work-sans', labelKey: 'storeBuilder.siteStyle.fontFrauncesWorkSans' },
]

export const STORE_BUILDER_FONT_PAIR_VALUES = new Set(
  STORE_BUILDER_FONT_PAIRS.map((row) => row.value),
)
